export interface NotificationsResponse {
  results: Notification[];
}

export interface NotificationUpdateParams {
  id: number;
  read: boolean;
  delete: boolean;
}

export interface UpdateNotificationsBody {
  notifications: NotificationUpdateParams[];
}

export const NotificationFilter = {
  ALL: "all",
  UNREAD: "unread",
  READ: "read",
} as const;
export type NotificationFilter =
  (typeof NotificationFilter)[keyof typeof NotificationFilter];

export interface NotificationFilterSelectorProps {
  filter: NotificationFilter;
  onFilterChange: (filter: NotificationFilter) => void;
  counts: Record<NotificationFilter, number>;
}

export interface NotificationFilterOption {
  label: string;
  emptyMessage: string;
}
